<template>
  <div class="com-card" v-bind="$attrs">
    <div class="card-head" v-if="title || $slots.title || $slots.extra">
      <div class="fl">
        <b class="card-title" v-if="title">
          {{ title }}
        </b>
        <div v-else-if="$slots.title" class="card-title">
          <slot name="title"></slot>
        </div>
      </div>
      <div class="fr" v-if="$slots.extra">
        <slot name="extra"></slot>
      </div>
    </div>
    <div class="card-body">
      <slot></slot>
    </div>
    <div
      v-if="$slots.action"
      class="card-foot"
      :class="{
        'foot-divider': showFootDivider
      }"
    >
      <div class="fl"></div>
      <div class="fr">
        <slot name="action"></slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ComCard",
  props: {
    theme: {
      type: String,
      default: "default",
    },
    title: {
      type: String,
      default: "",
    },
    showFootDivider: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style scoped lang="less">
.com-card {
  background-color: #fff;
  padding: 15px;
  margin: 15px 0;
  border-top: 1px #efefef solid;
  border-bottom: 1px #efefef solid;

  .card-head {
    margin-bottom: 10px;
    display: flex;
    justify-content: space-between;
    align-items: center;

    .card-title {
      font-size: 16px;
    }
  }

  .card-foot {
    margin-top: 10px;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    align-items: center;

    &.foot-divider {
      border-top: 1px #efefef dashed;
      padding-top: 10px;
    }
    .fr{
      flex: 1;
      width: 0;
      display: flex;
      flex-wrap: wrap;
      justify-content: flex-end;
      gap: 10px;
    }
  }

}
</style>
